import { AfterViewInit, ChangeDetectorRef, Component, ComponentFactoryResolver, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { AppService } from "@api";
import { AlineacionImagenEnum } from "@componentes/Enums.enum";
import { FiltroModel } from "@componentes/Filtros/Filtro.model";
import { FiltrosComponent } from "@componentes/Filtros/Filtros.component";
import { TipoFiltroEnum } from "@componentes/Filtros/Filtros.enum";
import { RespuestaEstatusEnum } from "@enumeraciones/Enumeraciones.enum";
import { AlertaEnum } from "@mensaje/Enumeraciones/MensajeEnumeraciones.enum";
import { MensajeService } from "@mensaje/Mensaje.Service";
import { TranslateService } from "@ngx-translate/core";
import { SistemaService } from "@servicios/Sistema.Service";


@Component(
    {
        selector: 'consultaacuerdo_padre',
        templateUrl: './consultaacuerdo_padre.component.html',
        styleUrls: ['./consultaacuerdo_acuerdo.component.scss']
    })

export class ConsultaAcuerdoPadreComponent implements AfterViewInit{
  @Input() entidad!: any;
  @Input() accion!: {accionid: number, accion: string};
  @Output() output = new EventEmitter();
  consulta!: boolean;
  buscarcompetencia: boolean = false;
  buscarcriterio: boolean = false;

  grupo:any;
  materia:any;
  visual: number = 0;

  listageneral:any[] = [];
  listamaterias: any[] = [];
  listagrupos: any[] = [];
  listaobservacion: any[] = [];
  listapuesto: any[] = [];
  puesto:number = 0;
  puestolocal: number = 0;

  periodo:any;
  entidadbusqueda: any;


  entidadacuerdo:any;

  public AlineacionImagenEnum = AlineacionImagenEnum;
  constructor(private cdr: ChangeDetectorRef,private appService: AppService, private mensajeService: MensajeService, public sistemaService: SistemaService, public translate: TranslateService, public _cfr: ComponentFactoryResolver){

    }

    ngAfterViewInit(){
      this.puestolocal = this.entidad.puestosubid;
      this.visual = 1;
      this.periodo = {
        "periodoevaluacionid":this.entidad.periodoevaluacionid,
        "cicloid":this.entidad.cicloid,
      }
      this.entidadbusqueda = {
        "colaboradorid": this.entidad.colaboradorsubordinadoid,
        "puestoid": this.entidad.puestosubid,
        "profesorid": this.entidad.profesorid,
        "otropuesto": this.entidad.otropuesto,
        "departamentoid": this.entidad.departamentoid
      }
      //this.materiaygrupo();


    }

    getgrupo(materia:any){
      if(materia.length > 0){
        let datos = {};
        if(materia[0] == 0){
          datos = {"entidad":this.entidad, "periodo":this.periodo};
        }else{
          datos = {"entidad":this.entidad, "periodo":this.periodo, "materia":materia}
        }
        this.appService.Post("reporte/evaluacion/grupopadre",datos).then(res=>{
          if(res.status == RespuestaEstatusEnum.Success){
              this.listagrupos = res.data;
          }
        })
      }else{
        this.listagrupos = [];
      }

    }

    getmateria(){
      this.appService.Post("reporte/evaluacion/materiapadre",{"entidad":this.entidadbusqueda, "periodo":this.periodo}).then(res=>{
        if(res.status == RespuestaEstatusEnum.Success){
            this.listamaterias = res.data;
            if(this.listamaterias.length == 0){
              this.getgrupo([0]);
            }
        }
      })
    }
    consultar(){
      if(this.entidad.asignacionacuerdoresponsableid){
        if(this.puesto){
          this.CargarInfo(this.visual);
        }else{
          this.mensajeService.Alerta(AlertaEnum.Warning, "No se tienen seleccionado ningun puesto para visualizar resultados");
        }
      }else{
        this.CargarInfo(this.visual);
      }
    }

    VerPorCompetencia(event:any){
        this.listageneral = [];
        if(event){
          this.buscarcriterio = false;
          if(this.entidad.asignacionacuerdoresponsableid){
            if(this.puesto){
              this.visual = 3;
              this.CargarInfo(this.visual);
            }else{
              this.mensajeService.Alerta(AlertaEnum.Warning, "No se tienen seleccionado ningun puesto para visualizar resultados");
            }
          }else{
            this.buscarcriterio = false;
            this.visual = 3;
            this.CargarInfo(this.visual);
          }
        }else{
          if(this.entidad.asignacionacuerdoresponsableid){
            if(this.puesto){
              this.visual = 1;
              this.CargarInfo(this.visual);
            }else{
              this.mensajeService.Alerta(AlertaEnum.Warning, "No se tienen seleccionado ningun puesto para visualizar resultados");
            }
          }else{
            this.visual = 1;
            this.CargarInfo(this.visual);
          }
        }
        this.cdr.detectChanges();
    }

    VerPorCriterio(event:any){
        this.listageneral = [];
        if(event){
          this.buscarcompetencia = false;
          if(this.entidad.asignacionacuerdoresponsableid){
            if(this.puesto){
              this.visual = 2;
              this.CargarInfo(this.visual);
            }else{
              this.mensajeService.Alerta(AlertaEnum.Warning, "No se tienen seleccionado ningun puesto para visualizar resultados");
            }
          }else{
            this.buscarcompetencia = false;
            this.visual = 2;
            this.CargarInfo(this.visual);
          }
        }else{
          if(this.entidad.asignacionacuerdoresponsableid){
            if(this.puesto){
              this.visual = 1;
              this.CargarInfo(this.visual);
            }else{
              this.mensajeService.Alerta(AlertaEnum.Warning, "No se tienen seleccionado ningun puesto para visualizar resultados");
            }
          }else{
            this.visual = 1;
            this.CargarInfo(this.visual);
          }
        }
        this.cdr.detectChanges();
    }

    CargarInfo(tipovisualizar: number){
        this.appService.Post("reporte/evaluacion/preguntapadre",{"general":this.entidadbusqueda, "periodo": this.periodo, "agrupar":tipovisualizar, "materia":this.materia, "grupo":this.grupo, "puestolocal": this.puesto}).then(res=>{
            if(res.status == RespuestaEstatusEnum.Success){
                this.listageneral = res.data.datos;
                this.listaobservacion = res.data.observaciones;
                if(this.listageneral.length == 0 ){
                    this.mensajeService.Alerta(AlertaEnum.Warning, "No se encontró evaluaciones de padres de familia")
                }else{
                    this.listageneral.map((competencia: any) => {
                        competencia.colortext = this.cambiarcolor(competencia.color);
                    })
                }
                this.cdr.detectChanges();
            }
        })
    }

    cambiarcolor(color: any): string {
        let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(color);
        let val: any = [];
        if (result) {
            let r = parseInt(result[1], 16)
            let g = parseInt(result[2], 16)
            let b = parseInt(result[3], 16)
            val = this.rgbToHsl(r, g, b);
        }
        if (val[2] < 50) {
            return "colorblanco"
        } else {

            return "colornegro";
        }
    }

    rgbToHsl(r: any, g: any, b: any) {
        r /= 255;
        g /= 255;
        b /= 255;

        // Find greatest and smallest channel values
        let cmin = Math.min(r, g, b),
            cmax = Math.max(r, g, b),
            delta = cmax - cmin,
            h = 0,
            s = 0,
            l = 0;

        // Calculate hue
        // No difference
        if (delta == 0)
            h = 0;
        // Red is max
        else if (cmax == r)
            h = ((g - b) / delta) % 6;
        // Green is max
        else if (cmax == g)
            h = (b - r) / delta + 2;
        // Blue is max
        else
            h = (r - g) / delta + 4;

        h = Math.round(h * 60);

        // Make negative hues positive behind 360°
        if (h < 0)
            h += 360;

        // Calculate lightness
        l = (cmax + cmin) / 2;

        // Calculate saturation
        s = delta == 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));

        // Multiply l and s by 100
        s = +(s * 100).toFixed(1);
        l = +(l * 100).toFixed(1);

        return [h, s, l];
    }

    buscardatos(data:any){
      if(data){
        this.entidadbusqueda.puestoid = data;
        this.puestolocal = data;
        this.getmateria();
      }else{
        this.listageneral = [];
        this.listaobservacion = [];
        this.listamaterias = [];
        this.listagrupos = [];
      }
    }
  }
